import React, {useState} from "react";
import DeleteIcon from "../DeleteIcon";
import {showToast} from "../../../../helpers/showToast";
import {
    deleteServiceProvider
} from "../../../../api/methods";
import {Switch} from "@mui/material";

const ServiceProvidersList = ({serviceProviders, onSearchHandler}) => {
    const [searchValue, setSearchValue] = useState("");
    const [loading, setLoading] = useState({
        fetchingActivities: false,
        addingProvider: false,
    });
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);
    };

    const handleSearchClick = () => {
        onSearchHandler(searchValue);
    };

    const handleClearSearch = () => {
        setSearchValue("");
        onSearchHandler("");
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearchClick();
        }
        // handel when clear search by backspace
        if (e.key === 'Backspace' && searchValue.length <= 1) {
            console.log("clear search");
            onSearchHandler("");
        }
    };

    const changeStatusServiceProvider = (serviceProvider) => {

        setLoading((prev) => ({ ...prev, fetchingActivities: true }));
        //change serviceProvider.canBeDeleted to false
        serviceProvider.isEnabled = !serviceProvider.isEnabled;
        deleteServiceProvider(serviceProvider)
            .then((response) => {
                // Remove the deleted provider from the list

                handleSearchClick();
                showToast({
                    toastOptions: {type: "success",}, data: {
                        variant: 'success', text: `Service provider ${serviceProvider.isEnabled ? "Enabled" : "Disabled"} successfully`,
                    },
                });
            })
            .catch((error) => {
                console.error("Error deleting service provider:", error);
                showToast({
                    toastOptions: {type: "error",}, data: {
                        variant: 'error', text: error.error,
                    },
                })
            })
            .finally(() => {
                setLoading((prev) => ({ ...prev, fetchingActivities: false }));
            });
    }




    return (<div className="service-providers-list">
        <h3>Service Providers List</h3>

        <div className="search-box">
            <div className="d-flex gap-2 align-items-center">
                <input
                    type="text"
                    placeholder="Search by tax number..."
                    value={searchValue}
                    onChange={handleSearchChange}
                    onKeyDown={handleKeyPress}
                    className="form-control"
                />
                <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleSearchClick}
                >
                    Search
                </button>
                {searchValue && (<button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={handleClearSearch}
                >
                    Clear
                </button>)}
            </div>
        </div>

        <div className="table-responsive">
            <table className="table">
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Tax Number</th>
                    <th>Activity</th>
                    <th>Enabled</th>
                </tr>
                </thead>
                <tbody>
                {serviceProviders.length === 0 ? (<tr>
                    <td colSpan="4" style={{textAlign: "center", padding: "2rem"}}>
                        {searchValue ? "No service providers found matching your search." : "No service providers found. Add some service providers to get started."}
                    </td>
                </tr>) : (serviceProviders.map((provider, index) => (
                    <tr key={`${provider.taxNumber}-${provider.activity}-${index}`}>
                        <td>{provider.name}</td>
                        <td>{provider.taxNumber}</td>
                        <td>{provider.activity}</td>
                        { (<td>
                            <Switch
                                checked={provider.isEnabled}
                                onChange={() => changeStatusServiceProvider(provider)}
                                color="success"
                            />
                        </td>)}
                    </tr>)))}
                </tbody>
            </table>
        </div>

        {serviceProviders.length > 0 && (<div className="table-info">
            <p>Total Service Providers: {serviceProviders.length}</p>
        </div>)}
    </div>);
};

export default ServiceProvidersList;
